import React from 'react'
import Legalese from './Legalese'
import { CustomModal } from './Modals/Modal'
import { getLegalTextForPage } from '../../services/reservoir'
import { getCourseId } from '../../helpers/course'
import { submitStudentDeclaration, getSoneDeclaration, updateSoneDeclaration } from '../../services/vu'
import { getAttributeCourseStaticInfo } from '../../helpers/enrolment'
import { Checkbox, FormControlLabel, FormGroup } from '@mui/material'

class StudentDeclaration extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      submitting: false,

      attemptedToSubmit: false,
      obligation: false,

      studentDeclarationSubmitted: this.isStudentDeclarationSubmitted(),
      legalText: '',
      sequenceNumber: ''
    }
  }

  componentDidMount() {
    getLegalTextForPage('Submit').then(response => {
      const legalText = response.data && response.data[0] && response.data[0].attributes && response.data[0].attributes.body && response.data[0].attributes.body.value

      this.setState({
        legalText: legalText
      })
    })

    getSoneDeclaration(getAttributeCourseStaticInfo('courseSPKNo')).then(studentDeclaration => {
      this.setState({
        sequenceNumber: studentDeclaration.sequenceNumber
      })
    })
  }

  isStudentDeclarationSubmitted = () => {
    return !!JSON.parse(sessionStorage.getItem(`${getCourseId()}_STUDENT_DECLARATION_SUBMITTED`))
  }

  setStudentDeclarationSubmitted = () => {
    return sessionStorage.setItem(`${getCourseId()}_STUDENT_DECLARATION_SUBMITTED`, true)
  }

  handleSubmitStudentDeclaration = () => {
    if (!this.state.obligation) {
      this.setState({
        attemptedToSubmit: true
      })
    } else {
      this.setState({
        submitting: true
      })

      const studentDeclarationRequest = {
        sequenceNumber: this.state.sequenceNumber,
        studentPermissionType: 'MYVUE',
        isStudentPermissionGranted: true,
        studyPackageNumber: getAttributeCourseStaticInfo('courseSPKNo'),
        courseAvailYear: getAttributeCourseStaticInfo('availabilityYear'),
        studyPeriod: getAttributeCourseStaticInfo('studyPeriodCode')
      }

      updateSoneDeclaration(studentDeclarationRequest).then(
        response => {
          this.setStudentDeclarationSubmitted()

          this.setState({
            submitting: false,
            studentDeclarationSubmitted: this.isStudentDeclarationSubmitted()
          })
        },
        () => {
          this.setState({
            submitting: false
          })
        }
      )
    }
  }

  render() {
    return (
      <CustomModal className="modal-lg modal-manage-enrolment" isOpen={!this.state.studentDeclarationSubmitted} userCanClose={false} handleCloseModal={() => {}} title="Student Declaration">
        <div className="question-group">
          <Legalese text={this.state.legalText} />
        </div>

        <div className="question-group">
          <FormGroup>
            <FormControlLabel 
              label="I have read the Privacy Notice and agree to the Student Declaration" 
              control={
                <Checkbox
                  checked={this.state.obligation}
                  onChange={(event, isInputChecked) => this.setState({ obligation: isInputChecked })}
                />
              }
            />
          </FormGroup>
          
          {!this.state.obligation && this.state.attemptedToSubmit ? <div className="form-error">Please agree to the Student Declaration before submitting.</div> : null}
        </div>

        <div className="row">
          <div className="col-xs-12">
            <button onClick={this.handleSubmitStudentDeclaration} className="btn btn-lg btn-primary" disabled={this.state.submitting}>
              <span>{this.state.submitting ? 'Submitting...' : 'Start'}</span>
            </button>
          </div>
          {/*<div className="col-xs-12 col-sm-6">*/}
          {/*<button className=" btn btn-lg btn-cancel" onClick={this.handleCancel}>Cancel</button>*/}
          {/*</div>*/}
        </div>
      </CustomModal>
    )
  }
}

export default StudentDeclaration
